import React, { useEffect } from "react";
import BlogBanner from "../components/Blog/BlogBanner";
import BlogsAll from "../components/Blog/BlogsAll";
import { useLenis } from "lenis/react";

const BlogCombine = () => {
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, {
        duration: 1.2,
      });
    }
  }, [lenis]);
  return (
    <>
      <BlogBanner />
      <BlogsAll />
    </>
  );
};

export default BlogCombine;
